
export const ConnectorNames = {
  Injected: 'injected',
}
